import apiClient from './client'

export const login = (data: any) => {
  return apiClient
    .post('/auth/login', data)
    .then((res) => res.data)
}

export const requestOtp = (data: any) => {
  return apiClient
    .post('/auth/request-otp', data)
    .then((res) => res.data)
}

export const verifyOtp = (data: any) => {
  return apiClient
    .post('/auth/verify-otp', data)
    .then((res) => res.data)
}
